import React, { SyntheticEvent } from 'react';
import Modal from '@components/Modal/Modal';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import FormRow from '@components/Form/FormRow';
import InputText from '@components/Form/InputText';
import InputCheckbox from '@components/Form/InputCheckbox';
import * as Mutations from '@api/graphql/mutations';
import GraphQLClient from '@api/graphql/GraphQLClient';
import { Notification } from 'components/';
import { AllFormErrors, getAllFormErrors, EmptyFormErrors, getError } from '@root/utils/ErrorHelper';
import ButtonSave from '@components/Form/ButtonSave';
import ButtonCancel from '@components/Form/ButtonCancel';
import { connect, DispatchProp } from 'react-redux';
import { ToastActionType } from '@actions/toastActions';
import { ToastLevelType } from '@components/Toast/Toast';

interface FormDataType {
    id?: number;
    label: string;
    is_active?: boolean;
    is_default?: boolean;
    product_attribute_id?: number;
    after?: number;
}


type Props = {
    visible: boolean;
    data: FormDataType;
    onClose: () => void;
} & InjectedIntlProps & DispatchProp;

interface State {
    data: FormDataType;
    allFormErrors: AllFormErrors;
}

class ProductAttributeOptionModal extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            data: props.data,
            allFormErrors: EmptyFormErrors,
        };
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({data: props.data});
    }

    private renderModalButtons = () => {
        return (
            <div className="form-group">
                <div className="col-sm-6">
                    <ButtonCancel className="pull-left" onClick={(e: SyntheticEvent) => { this.props.onClose(); }} />
                </div>
                <div className="col-sm-6 pull-right">
                    <ButtonSave className="pull-right" onClick={this.onSubmit} disabled={!this.state.data.label} />
                </div>
            </div>
        );
    }


    private onSubmit = (e: SyntheticEvent) => {
        e.preventDefault();
        const mutation = this.state.data.id ? Mutations.updateProductAttributeOption : Mutations.createProductAttributeOption;
        GraphQLClient.mutate({
            mutation, variables: this.state.data,
        }).then(() => {
            this.props.dispatch({type: ToastActionType.addToast, toast: {
                id: 'product-attribute-save-success',
                text: this.props.intl.formatMessage({ id: 'notification.succeed' }),
                type: ToastLevelType.success,
                timeout: 2000,
            }});

            this.props.onClose();
        }).catch((error: any) => {
            const allFormErrors = getAllFormErrors(error);
            this.setState({allFormErrors});

            Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
        });
    }

    private renderForm = () => {
        return (
            <>
                <FormRow label="Címke" error={getError('label', this.state.allFormErrors)} labelWidth={3}>
                    <InputText name="label" value={this.state.data.label} required={true} onChangeHandler={(value, name) => {
                        this.setState({data: {...this.state.data, label: value}});
                    }} />
                </FormRow>
                <FormRow label="Aktív" error={getError('is_active', this.state.allFormErrors)} labelWidth={3}>
                    <InputCheckbox name="is_active" value={this.state.data.is_active} onChangeHandler={(value, name) => {
                        this.setState({data: {...this.state.data, is_active: value}});
                    }} />
                </FormRow>
            </>
        );
    }

    public render() {
        return (
            <Modal
                visible={this.props.visible}
                title={this.props.data.id ? 'Opció szerkesztése' : 'Új opció'}
                onClose={this.props.onClose}
                renderButtons={this.renderModalButtons}
                renderBody={this.renderForm}
            />
        );
    }
}

export default compose(
    injectIntl,
    connect(null),
)(ProductAttributeOptionModal);



// WEBPACK FOOTER //
// ./src/modules/ProductAttribute/components/ProductAttributeOptionModal.tsx